<template>
  <el-drawer :title="title" :visible.sync="open" :direction="direction" :before-close="handleClose"
    close-on-press-escape :destroy-on-close="true" :wrapperClosable="false" :size="width">
    <div class="drawBox">
      <div class="content">
        <slot name="content"></slot>
      </div>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    title: {
      typeof: String,
      default() {
        return "详情";
      },
    },
    open: {
      typeof: Boolean,
      default() {
        return false;
      },
    },
    width:{
      typeof: Number,
      default() {
        return 750;
      },
    }
  },
  data() {
    return {
      direction: "rtl",
    };
  },
  methods: {
    handleClose() {
      this.$emit("changeOpen");
      // this.$confirm("确认关闭？")
      //   .then(() => {
      //     this.$emit("changeOpen");
      //   })
      //   .catch();
    },
  },
};
</script>

<style scoped lang="scss">
.drawBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
    height: 0;
    width: 100%;
    overflow: overlay;
    box-sizing: border-box;
    padding: 10px;
  }

  .footer {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 20px;
  }
}

::v-deep {
  .el-drawer__header {
    padding: 8px 20px;
    margin: 0;
    background: #f6f7f9;
    user-select: none;
    color: #404961;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    font-size: 14px;
  }
}
</style>